export default __webpack_public_path__ + "static/media/google-2.e12914ad.png";